import { PageMeta } from "@/components/common/Seo/PageMeta"
import MCPPage from "@/components/products/mcp/MCPPage"
import { ProductSchema } from "@/components/products/ProductSchema"

const index = () => (
  <>
    <ProductSchema id="mcp" />
    <PageMeta
      meta={{
        title: "MCP server for crypto data",
        description:
          "Connect Token Terminal's onchain data to Claude and ChatGPT with our MCP server, and query crypto metrics in natural language. Set up the MCP server today.",
      }}
    />
    <MCPPage />
  </>
)

export default index
